import { useCallback, useEffect, useState } from "react";
import { TfaMethod } from "@/core/constants/tfaMethod";
import AuthMpProvider from "@/core/data-provider/data-mp/auth/auth-mp-provider";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import useAppSelector from "@/core/helpers/useAppSelector";
import {
  enableResetPasswordMethodsSelector,
  resetPasswordMethodSelector,
  setResetPasswordMethod,
} from "@/domains/auth/slice";
import useGetEnableTfaMethods from "@/domains/auth/hooks/useGetEnableTfaMethods";
import AuthResetPasswordAuthenticatorContainer from "@/domains/auth/containers/reset-password/method/AuthResetPasswordAuthenticatorContainer";
import AuthResetPasswordEmailContainer from "@/domains/auth/containers/reset-password/method/AuthResetPasswordEmailContainer";
import AuthResetPasswordSMSContainer from "@/domains/auth/containers/reset-password/method/AuthResetPasswordSMSContainer";
import AuthTitle from "@/domains/auth/components/AuthTitle";
import AuthResetPasswordMethods from "@/domains/auth/components/reset-password/AuthResetPassword";

const methodContainerMap = {
  [TfaMethod.AUTHENTICATOR]: AuthResetPasswordAuthenticatorContainer,
  [TfaMethod.EMAIL]: AuthResetPasswordEmailContainer,
  [TfaMethod.SMS]: AuthResetPasswordSMSContainer,
};

export default function AuthResetPasswordContainer() {
  useGetEnableTfaMethods();
  const dispatch = useAppDispatch();
  const method = useAppSelector(resetPasswordMethodSelector);
  const [currMethod, setCurrMethod] = useState(method);
  const enableResetPasswordMethods = useAppSelector(enableResetPasswordMethodsSelector);

  useEffect(() => {
    setCurrMethod(method);
  }, [method]);

  const onConfirmMethod = useCallback(() => {
    if (!currMethod) return;
    dispatch(setResetPasswordMethod(currMethod));
  }, [dispatch, currMethod]);

  const SelectedMethodContainer = methodContainerMap[method];

  if (method) {
    return <SelectedMethodContainer />;
  }

  return (
    <>
      <AuthTitle back={AuthMpProvider.goToSignIn}>Восстановление пароля</AuthTitle>
      <AuthResetPasswordMethods
        currMethod={currMethod}
        enableMethods={enableResetPasswordMethods}
        onChangeMethod={setCurrMethod}
        onSubmit={onConfirmMethod}
      />
    </>
  );
}
